import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = { context: { clientName: 'toy' } } as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Time: string;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a sweet */
  createSweet: Maybe<Sweet>;
  /** Creates a sweet order */
  createSweetOrder: SweetOrder;
};

export type MutationCreateSweetArgs = {
  expiresAt: Scalars['Time'];
  title: Scalars['String'];
};

export type MutationCreateSweetOrderArgs = {
  input: SweetOrderInput;
};

export type Query = {
  __typename?: 'Query';
  /** Get a sweet from the Toy shop. */
  sweet: Maybe<Sweet>;
  /** Get a sweet order from the Toy shop. */
  sweetOrder: SweetOrder;
  /** Get all the sweet orders from the Toy shop. */
  sweetOrders: Array<SweetOrder>;
  /** Get all the sweets from the Toy shop. */
  sweets: Maybe<Array<Sweet>>;
};

export type QuerySweetArgs = {
  id: Scalars['String'];
};

export type QuerySweetOrderArgs = {
  id: Scalars['ID'];
};

export type Sweet = {
  __typename?: 'Sweet';
  /** The time the sweet was created */
  created_at: Scalars['Time'];
  /** The time the sweet expires */
  expires_at: Scalars['Time'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The title of the sweet */
  title: Scalars['String'];
};

export type SweetOrder = {
  __typename?: 'SweetOrder';
  /** The time the sweet order was created */
  created_at: Scalars['Time'];
  /** The time the sweet order expires */
  expires_at: Scalars['Time'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The sweet & quantity pairs being ordered */
  items: Array<SweetOrderItem>;
};

export type SweetOrderInput = {
  /** List of sweet & quantity pairs */
  items: Array<SweetOrderItemInput>;
};

export type SweetOrderItem = {
  __typename?: 'SweetOrderItem';
  /** The time the sweet order item was created */
  created_at: Scalars['Time'];
  /** The time the sweet order item expires */
  expires_at: Scalars['Time'];
  /** Unique ID */
  id: Scalars['ID'];
  /** The amount of sweets being ordered */
  quantity: Scalars['Int'];
  /** The sweet being ordered */
  sweet: Sweet;
};

export type SweetOrderItemInput = {
  /** Quantity of being ordered */
  quantity: Scalars['Int'];
  /** ID of the sweet being ordered */
  sweetId: Scalars['ID'];
};

/**
 * This type is required for schema validation to pass.
 * https://www.apollographql.com/docs/federation/v1/federation-spec/#type-_service
 */
export type _Service = {
  __typename?: '_Service';
  sdl: Scalars['String'];
};

export type CreateSweetMutationVariables = Exact<{
  title: Scalars['String'];
  expiresAt: Scalars['Time'];
}>;

export type CreateSweetMutation = {
  __typename?: 'Mutation';
  createSweet: { __typename?: 'Sweet'; id: string; title: string; created_at: string; expires_at: string } | null;
};

export type SweetsQueryVariables = Exact<{ [key: string]: never }>;

export type SweetsQuery = {
  __typename?: 'Query';
  sweets: Array<{ __typename?: 'Sweet'; id: string; title: string; created_at: string; expires_at: string }> | null;
};

export const CreateSweetDocument = gql`
  mutation createSweet($title: String!, $expiresAt: Time!) {
    createSweet(title: $title, expiresAt: $expiresAt) {
      id
      title
      created_at
      expires_at
    }
  }
`;
export type CreateSweetMutationFn = Apollo.MutationFunction<CreateSweetMutation, CreateSweetMutationVariables>;

/**
 * __useCreateSweetMutation__
 *
 * To run a mutation, you first call `useCreateSweetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSweetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSweetMutation, { data, loading, error }] = useCreateSweetMutation({
 *   variables: {
 *      title: // value for 'title'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useCreateSweetMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSweetMutation, CreateSweetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSweetMutation, CreateSweetMutationVariables>(CreateSweetDocument, options);
}
export type CreateSweetMutationHookResult = ReturnType<typeof useCreateSweetMutation>;
export type CreateSweetMutationResult = Apollo.MutationResult<CreateSweetMutation>;
export type CreateSweetMutationOptions = Apollo.BaseMutationOptions<CreateSweetMutation, CreateSweetMutationVariables>;
export const SweetsDocument = gql`
  query Sweets {
    sweets {
      id
      title
      created_at
      expires_at
    }
  }
`;

/**
 * __useSweetsQuery__
 *
 * To run a query within a React component, call `useSweetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSweetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSweetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSweetsQuery(baseOptions?: Apollo.QueryHookOptions<SweetsQuery, SweetsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SweetsQuery, SweetsQueryVariables>(SweetsDocument, options);
}
export function useSweetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SweetsQuery, SweetsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SweetsQuery, SweetsQueryVariables>(SweetsDocument, options);
}
export type SweetsQueryHookResult = ReturnType<typeof useSweetsQuery>;
export type SweetsLazyQueryHookResult = ReturnType<typeof useSweetsLazyQuery>;
export type SweetsQueryResult = Apollo.QueryResult<SweetsQuery, SweetsQueryVariables>;
